export function findSelectedSku(contentData, currentAttributeState) {
  return contentData.skus.find((sku) => {
    return sku.definingAttributes.every((attribute) => {
      const selected = currentAttributeState[attribute.name]?.selectedValue;
      return (
        selected !== undefined && selected.toString().toLowerCase() === attribute.value.value.toString().toLowerCase()
      );
    });
  });
}

export async function fetchImboxAvailability(selectedSku, { wasParms }, quantity) {
  try {
    const response = await fetch('/wcs/resources/store/301/dynamicInventory/GetSkuInformation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sku: selectedSku.partnumber }),
      credentials: 'omit',
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    const skuInfoArr = data?.response?.skuInformation;
    const skuInformation =
      Array.isArray(skuInfoArr) && skuInfoArr[0] && Object.keys(skuInfoArr[0]).length > 0 ? skuInfoArr[0] : null;
    if (!skuInformation) return false;
    const onHand0698Num = Number(skuInformation.rsvdtlOutput?.onHand0698);
    const imboxWasparm = Number(wasParms.imboxOnHandThreshold);
    const quantityNum = Number(quantity);
    const quantityGreaterThanOnhand = quantityNum > onHand0698Num;
    return (
      !isNaN(onHand0698Num) &&
      onHand0698Num !== 0 &&
      !isNaN(imboxWasparm) &&
      onHand0698Num >= imboxWasparm &&
      !quantityGreaterThanOnhand
    );
  } catch (error) {
    console.error('Error fetching SKU information:', error);
    return false;
  }
}

export async function shouldShowImboxModal({ passedAppFunctions, contentData, currentAttributeState, quantity }) {
  const isCountryUS = passedAppFunctions?.country === 'US';
  const imboxWasparm = !!(
    passedAppFunctions?.wasParms?.imboxOnHandThreshold && passedAppFunctions.wasParms.imboxOnHandThreshold !== '0'
  );
  const itemCanBeImboxed = contentData.skus.some((sku) => sku.imbox === true);

  if (isCountryUS && imboxWasparm && itemCanBeImboxed) {
    const selectedSku = findSelectedSku(contentData, currentAttributeState);
    if (selectedSku?.imbox === true) {
      const imboxAvailable = await fetchImboxAvailability(selectedSku, passedAppFunctions, quantity);
      return !!imboxAvailable;
    }
  }
  return false;
}
